import { createFileRoute } from '@tanstack/react-router'
import { guardParentOnly } from '@/lib/auth/routeGuards'
import ParentAttendanceView from '@/components/ParentPage/ParentAttendanceView'

export const Route = createFileRoute('/parent')({
  component: RouteComponent,
  beforeLoad: guardParentOnly,
})

function RouteComponent() {
  return <ParentAttendanceView />
}
